/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Search_PlaceholderInputs */

const en_home_v2_search_placeholder = /** @type {(inputs: Home_V2_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search your library…`)
};

const es_home_v2_search_placeholder = /** @type {(inputs: Home_V2_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca en tu biblioteca…`)
};

/**
* | output |
* | --- |
* | "Search your library…" |
*
* @param {Home_V2_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_search_placeholder = /** @type {((inputs?: Home_V2_Search_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Search_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_search_placeholder(inputs)
	return en_home_v2_search_placeholder(inputs)
});